import type { IBannerDescriptionProps } from './Description'

import { styled } from '@linaria/react'
import {
  BannerDescriptionAlignItems,
  BannerDescriptionColumnGap,
  BannerDescriptionDirection,
  BannerDescriptionRowGap,
} from './Description.h'

export const BannerDescriptionStyled = styled.div<IBannerDescriptionProps>`
  display: flex;
  width: ${({ width }) => (width ? `var(${width})` : `0`)};
  max-width: 100%;
  flex-direction: ${({ direction }) =>
    direction || BannerDescriptionDirection.Row};
  align-items: ${({ alignItems }) =>
    alignItems || BannerDescriptionAlignItems.FlexStart};
  row-gap: ${({ rowGap }) =>
    `var(${rowGap || BannerDescriptionRowGap.INDENT_20})`};
  column-gap: ${({ columnGap }) =>
    `var(${columnGap || BannerDescriptionColumnGap.INDENT_20})`};
`
